import type {EntryPoint} from 'react-relay'
import type {LoaderFunctionArgs} from 'react-router'
import {getRequest} from 'relay-runtime'

import type {ThinNestedEntryPointParamsObject} from '../../../../types/entryPoints'
import {makeResource} from '../../../../utils/makeResource'
import {queryToObject} from '../../../../utils/queryParams'

import type {EditPipelinePageComponent, NestedEntryPoints} from './EditPipelinePage.container'
import {query} from './EditPipelinePage.queries'
import {EditPipelineYAMLEntryPoint} from './EditPipelineYAML/EditPipelineYAML.entryPoint'
import {JobSettingsSidebarEntryPoint} from './SettingsSidebarContent/JobSettingsSidebar/JobSettingsSidebar.entryPoint'

export const EditPipelinePageEntryPoint: EntryPoint<EditPipelinePageComponent, LoaderFunctionArgs> =
  {
    root: makeResource(
      'EditPipelinePage',
      () => import(/* webpackChunkName: "EditPipelinePage" */ './EditPipelinePage.container'),
    ),
    getPreloadProps: ({params, request}) => {
      const entryPoints: ThinNestedEntryPointParamsObject<NestedEntryPoints> = {
        editPipelineYAML: {
          entryPoint: EditPipelineYAMLEntryPoint,
          entryPointParams: {},
        },
      }
      const url = new URL(request.url)
      const {job} = queryToObject(url.search)
      if (job != null) {
        entryPoints.jobSettingsSidebar = {
          entryPoint: JobSettingsSidebarEntryPoint,
          entryPointParams: {},
        }
      }

      return {
        queries: {
          pipeline: {
            parameters: getRequest(query),
            variables: {locator: `id:${params.pipelineId}`},
            options: {networkCacheConfig: {metadata: {essential: true}}},
          },
        },
        entryPoints,
      }
    },
  }
